import React from 'react';
import { userAppData } from '../MainApp.js';
import { Outlet, useNavigate } from "react-router-dom";
import './itSupport.css';



export default function ItSupport() {
    let navigate = useNavigate();
    const itUser = userAppData["itRequestsData"]['perms'];

    if (itUser == 0) {
        navigate("/app");
    }
    
    return (
        <div className='main_div'>
            <Outlet />
        </div>
    )
};